import { supabase } from '../lib/supabase';

export const authService = {
  async signIn(email, password) {
    const { data, error } = await supabase?.auth?.signInWithPassword({
      email,
      password
    });
    if (error) throw error;
    return data;
  },

  async signInWithGoogle() {
    const { data, error } = await supabase?.auth?.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location?.origin}/admin-portal-dashboard`
      }
    });
    if (error) throw error;
    return data;
  },

  async signOut() {
    const { error } = await supabase?.auth?.signOut();
    if (error) throw error;
  },

  async getCurrentUser() {
    const { data: { user }, error } = await supabase?.auth?.getUser();
    if (error) throw error;
    return user;
  },

  async getCurrentSession() {
    const { data: { session }, error } = await supabase?.auth?.getSession();
    if (error) throw error;
    return session;
  }
};
